/**
 * Opens a URL in a new tab and tries to keep focus on the current page.
 * Omits noopener so the new window reference can be blurred (noopener returns null).
 * @param {string} url - URL to open.
 * @returns {boolean} Whether a new tab/window was opened.
 */
const openUrlInBackground = (url) => {
  const popup = window.open(url, '_blank', 'noreferrer');
  if (!popup) return false;

  try {
    popup.blur();
    window.focus();
  } catch (_) {
    // Blur/focus may be blocked by the browser; tab still opens.
  }

  return true;
};

export default openUrlInBackground;
